import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';
export function Guarantee() {
  const points = ['Sin contratos a largo plazo — mes a mes, cancela cuando quieras', 'Resultados medibles desde el primer mes', 'Si no generamos resultados en 90 días, trabajamos gratis hasta lograrlo'];
  return <section className="py-20 md:py-28 px-4 bg-carbon relative border-t border-border flex justify-center" data-id="element-166">
      <motion.div className="max-w-4xl w-full bg-surface border border-gold/20 rounded-3xl p-8 md:p-16 shadow-[0_0_40px_rgba(242,183,5,0.05)] text-center relative overflow-hidden" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }} data-id="element-167">
        {/* Subtle glow behind shield */}
        <div className="absolute top-12 left-1/2 -translate-x-1/2 w-32 h-32 bg-gold/10 rounded-full blur-2xl pointer-events-none" data-id="element-168" />

        <div className="relative z-10 flex flex-col items-center" data-id="element-169">
          <ShieldCheck className="w-20 h-20 text-gold mb-8" strokeWidth={1.5} data-id="element-170" />

          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-6 tracking-tight" data-id="element-171">
            Nuestra Garantía
          </h2>

          <p className="text-lg md:text-xl text-neutral-300 leading-relaxed mb-12 max-w-3xl" data-id="element-172">
            No te pedimos que confíes ciegamente. Te pedimos una conversación de
            15 minutos. Si después de nuestra llamada estratégica no ves un
            camino claro para duplicar tus clientes premium, te lo diremos
            honestamente — sin presión, sin compromiso.
          </p>

          <div className="w-full max-w-2xl text-left space-y-4" data-id="element-173">
            {points.map((point, index) => <motion.div key={index} className="flex items-start gap-4 bg-carbon/50 p-4 rounded-xl border border-border" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3 + index * 0.1,
            duration: 0.5
          }} data-id="element-174">
                <CheckCircle2 className="w-6 h-6 text-emerald shrink-0 mt-0.5" data-id="element-175" />
                <span className="text-white font-medium" data-id="element-176">{point}</span>
              </motion.div>)}
          </div>
        </div>
      </motion.div>
    </section>;
}